import { useEffect, useRef, useState } from 'react';
import './components/Task';
import Task from './components/Task';
import './styles/style.css';


const TaskList = ({el,setTaskList,taskList,theme,index,dragItem,dragOver})=>{

    const handleSort = ()=>{
        let _taskList = [...taskList]
        //tolgo l'elemento dall'array principale e me lo salvo
        const draggedItemContent = _taskList.splice(dragItem.current,1)[0] //a partire dal dragitem.current elimino un elemento, resrtituisce l elemento eliminato
        //aggiungo l'elemnto eliminato
        _taskList.splice(dragOver.current,0,draggedItemContent) //scambio la posizione
        //resetto gli indici e aggiorno la lista
        dragItem.current = null
        dragOver.current = null
        setTaskList(_taskList)
    }

    //aggiorno gli indici
    const onDragStart = (e,index)=>{
        dragItem.current =index
    }
    const onDragEnter = (e,index)=>{
        dragOver.current=index
    }

    function handleUpdateTask(){
        el.completed = !el.completed
        setTaskList(tasks=>[...tasks])
    }
    function handleDelete(){
        setTaskList(taskList=>
            taskList.filter(task=>task.task!==el.task)
        )
        localStorage.setItem("todos",JSON.stringify(taskList))
    }

    
    const element = (
        <div className='rigth'>
            <div className={"text " + (el.completed ? "done "+theme:"")}>
            {el.task}
            </div>
            <div className='delete' onClick={handleDelete}>
                 <img src='./images/icon-cross.svg' alt='cross'/>
            </div>
        </div>
    )
    return <Task draggable 
                 onDragStart={e=>onDragStart(e,index)}
                 onDragEnter={e=>onDragEnter(e,index)}
                 onDragEnd={handleSort}
                 onDragOver={e=>e.preventDefault()}
                 element={element} 
                 task={el} 
                 theme={theme} 
                 handleUpdateTask={handleUpdateTask}/>

    
}


const TaskInput = ({setTask,setTaskList,task,taskList,theme})=>{
    function handleSubmit(e){
        e.preventDefault()
        for (let i =0;i<taskList.length;i++)
            if(taskList[i].task===task){
                setTask("")
                return
            }
        
        let t = {
            task,
            completed:false,
            show:true
        }
        setTaskList([...taskList,t])
        localStorage.setItem("todos",JSON.stringify(taskList))
        setTask("")
    }
    const element = 
        <form onSubmit={handleSubmit} >
        <input className={theme} type="text"  placeholder="create a new todo..." value={task} onChange={e=>setTask(e.target.value)}  />
        </form>
    return <Task theme={theme} element={element}/>
}

const Todo = ({theme,changeTheme})=>{

    let todos = localStorage.getItem("todos")
    let state = localStorage.getItem("filter")
    if(todos===null)
        localStorage.setItem("todos","[]")
    if(state===null)
        localStorage.setItem("filter","All")

    const dragItem = useRef(null)
    const dragOver = useRef(null)

    const [task,setTask] = useState("")
    const [filter,setFilter] = useState(localStorage.getItem("filter"))
    const [taskList,setTaskList] = useState(JSON.parse(localStorage.getItem("todos")))


    useEffect(()=>{
        localStorage.setItem("todos",JSON.stringify(taskList))
    },[taskList])
    useEffect(()=>{
        localStorage.setItem("filter",filter)
    },[filter])


    function handleClearCompleted(){
        setTaskList(taskList=>taskList.filter(task=>!task.completed))
        localStorage.setItem("todos",JSON.stringify(taskList))
    }
    function handleAll(){
        setFilter("All")
        setTaskList(taskList=>taskList.map(task=>{
            task.show = true
            return task
        }))
        
 
    }
    function handleCompleted(){
        setFilter("Completed")
        setTaskList(taskList=>taskList.map(task=>{
            task.show = task.completed
            return task
        }))
  
    }
    function handleActive(){
        setFilter("Active")
        setTaskList(taskList=>taskList.map(task=>{
            task.show = !task.completed
            return task
        }))
   
    }
    return (
        <div className="todo">
            <div className="top">
                <div className="title">
                    <h1> T O D O </h1>
                    <img src={"./images/icon-"+(theme==="dark" ?"sun":"moon")+".svg"} alt="mode" onClick={changeTheme}/>
                </div>
                <div className="inputBar">
                    <TaskInput theme={theme} setTask={setTask} task={task} setTaskList={setTaskList} taskList={taskList}/>
                </div>
            </div>
            <div className={'bottom '+theme}>
                    {taskList.map((el,i)=>
                        el.show && <TaskList dragItem={dragItem} dragOver={dragOver} index={i} theme={theme} el={el} key={el.task} taskList={taskList} setTaskList={setTaskList}/>
                    )}
            </div>
            <div className={"panel "+theme}>
                  <div className={'left '+theme}>
                    <div className='content'>
                        { 
                            taskList.filter(el=>!el.completed).length + (taskList.filter(el=>!el.completed).length===1 ? " item ":" items")}  left
                    </div>
                  </div>
                  <div className={'center '+theme}> 
                  <div className={"content "+ (filter==="All" ? "selected":"")} onClick={handleAll}>
                        All
                    </div>
                    <div className={"content "+ (filter==="Active" ? "selected":"")} onClick={handleActive}>
                        Active
                    </div>
                    <div className={"content "+ (filter==="Completed" ? "selected":"")} onClick={handleCompleted}>
                        Completed
                    </div>
                  </div> 
                  <div className={'rigth '+theme}>
                    <div className='content' onClick={handleClearCompleted}>
                        Clear Completed
                    </div>
                </div> 
            </div>
        </div>
    )
}
export default Todo;